import styled from 'styled-components';
import { TimbaStanding } from '../api/client';

// Tabla de posiciones reutilizable. Muestra el top `top` (medallas a los 3 primeros) y, si el
// jugador no entra en ese top, agrega su fila abajo con su puesto real. Resalta su fila (filete).
export function TimbaBoard({ standings, pub, top = 10 }: { standings: TimbaStanding[]; pub: string; top?: number }) {
  if (standings.length === 0) {
    return <Empty>Todavía no hay pronósticos. ¡Sé el primero!</Empty>;
  }
  const row = (r: TimbaStanding, i: number) => (
    <li key={r.pub} className={r.pub === pub ? 'me' : ''}>
      <span className="pos">{i < 3 ? ['🥇', '🥈', '🥉'][i] : i + 1}</span>
      <span className="who">{r.nick}{r.pub === pub ? ' (vos)' : ''}</span>
      <span className="meta">{r.exacts} exactos · {r.played} jug.</span>
      <span className="pts">{r.points}</span>
    </li>
  );
  const head = standings.slice(0, top);
  const myIdx = standings.findIndex((r) => r.pub === pub);
  return (
    <>
      <Ol className="scroll">{head.map((r, i) => row(r, i))}</Ol>
      {myIdx >= top && <Ol className="meRow">{row(standings[myIdx], myIdx)}</Ol>}
    </>
  );
}

const Empty = styled.p`
  padding: 16px 14px;
  margin: 0;
  font-size: 0.88rem;
  color: ${({ theme }) => theme.colors.textMuted};
`;

const Ol = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  &.scroll { max-height: 396px; overflow-y: auto; }
  &.meRow { border-top: 2px dashed ${({ theme }) => theme.colors.borderStrong}; }
  &.meRow li { border-top: none; }
  li { display: flex; align-items: center; gap: 10px; padding: 11px 14px; border-top: 1px solid ${({ theme }) => theme.colors.border}; }
  li:first-child { border-top: none; }
  li.me { background: rgba(26, 168, 106, 0.14); box-shadow: inset 0 0 0 2px ${({ theme }) => theme.colors.accent}; }
  li.me .who { color: ${({ theme }) => theme.colors.accent}; }
  .pos { width: 26px; font-size: 1.05rem; font-weight: 800; text-align: center; color: ${({ theme }) => theme.colors.textMuted}; }
  .who { flex: 1; font-weight: 700; }
  .meta { font-size: 0.74rem; color: ${({ theme }) => theme.colors.textMuted}; }
  .pts { font-weight: 900; font-size: 1.15rem; color: ${({ theme }) => theme.colors.accent}; min-width: 32px; text-align: right; }
`;
